/* OXXRING v2 quick finder (snippets/oxx-ic-quickfind-box.liquid: home hero, collections, 404).
   Exact rows are server-rendered through the Section Rendering API (sections/oxx-ic-wp6-row.liquid),
   so price, pack picker, quick add and ordering state come from the same router the product page uses.
   A box renders its results inside itself, or into the element named by data-results (home hero). */
(function () {
  'use strict';
  var MAX_ROWS = 8;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function num(v) { var s = String(v || '').trim().replace(',', '.'); return /^\d*\.?\d+$/.test(s) ? parseFloat(s) : NaN; }
  function f2(n) { return Number(n).toFixed(2); }
  function track(name, detail) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, detail || {})); }

  var rowCache = {};
  function fetchRow(handle) {
    if (!rowCache[handle]) {
      rowCache[handle] = fetch('/products/' + handle + '?section_id=oxx-ic-wp6-row', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var t = document.createElement('template'); t.innerHTML = html; return t.content.querySelector('tr'); })
        .catch(function () { return null; });
    }
    return rowCache[handle].then(function (tr) { return tr ? tr.cloneNode(true) : null; });
  }

  function init(root) {
    var X = window.OXXIC;
    if (!X || root.dataset.icReady) return;
    var out = root.dataset.results ? document.getElementById(root.dataset.results) : root.querySelector('[data-ic-qf-results]');
    if (!out) return;
    root.dataset.icReady = '1';
    var finder = root.dataset.finderUrl, rfq = root.dataset.rfqUrl, src = root.dataset.source || 'home-finder';
    var tabs = [].slice.call(root.querySelectorAll('[data-ic-qf-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-ic-qf-panel]'));
    var ring = document.querySelector('[data-ic-ring]');
    var seq = 0, timer;

    // The three tab panels are different heights (measured at 1440px: size 264, dash 164, text 146), so
    // switching tabs collapsed the card by up to 118px and pushed the rest of the page up with it. Reserve
    // the tallest panel's height on every panel so the card keeps one size whatever tab is open.
    function reserveHeight() {
      if (panels.length < 2) return;
      var i, max = 0, prev = [];
      for (i = 0; i < panels.length; i++) { prev.push(panels[i].hidden); panels[i].hidden = false; }
      for (i = 0; i < panels.length; i++) max = Math.max(max, panels[i].getBoundingClientRect().height);
      for (i = 0; i < panels.length; i++) panels[i].hidden = prev[i];
      if (max <= 0) return;
      max = Math.ceil(max);
      panels.forEach(function (p) { p.style.minHeight = max + 'px'; });
    }
    reserveHeight();
    // Re-measure after webfonts settle and on resize/rotation: the tallest panel changes with the layout.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserveHeight).catch(function () {});
    window.addEventListener('load', reserveHeight);
    var rTimer;
    window.addEventListener('resize', function () { clearTimeout(rTimer); rTimer = setTimeout(reserveHeight, 150); });

    function select(name, focus) {
      tabs.forEach(function (t) { var on = t.dataset.icQfTab === name; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p) {
        p.hidden = p.dataset.icQfPanel !== name;
        if (!p.hidden && focus) { var f = p.querySelector('input:not([type="hidden"]):not([type="radio"])'); if (f) f.focus(); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.dataset.icQfTab, true); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; select(n.dataset.icQfTab, false); n.focus();
      });
    });

    // Placeholders follow the unit (20.00 × 2.50 mm, 0.984 × 0.139 in).
    function placeholders(unit) {
      [].forEach.call(root.querySelectorAll('[data-ph-' + unit + ']'), function (i) { i.placeholder = i.getAttribute('data-ph-' + unit); });
    }
    [].forEach.call(root.querySelectorAll('input[name="unit"]'), function (r) {
      r.addEventListener('change', function () { if (r.checked) placeholders(r.value); });
    });

    function setRing(id, cs) {
      if (!ring) return;
      var idT = ring.querySelector('[data-ic-ring-id]'), csT = ring.querySelector('[data-ic-ring-cs]');
      if (idT) idT.textContent = id ? 'ID ' + f2(id) + ' mm' : 'ID inside diameter';
      if (csT) csT.textContent = cs ? 'CS ' + f2(cs) + ' mm' : 'CS cross section';
      var band = ring.querySelector('[data-ic-ring-band]');
      if (band && id && cs) {
        var w = Math.max(6, Math.min(64, cs * 192 / (id + 2 * cs)));
        band.setAttribute('stroke-width', w.toFixed(1)); band.setAttribute('r', (96 - w / 2).toFixed(1));
        var shine = ring.querySelector('[data-ic-ring-shine]'); if (shine) { shine.setAttribute('r', (96 - w / 2).toFixed(1)); shine.setAttribute('stroke-width', (w * 0.3).toFixed(1)); }
        var line = ring.querySelector('[data-ic-ring-id-line]'); if (line) { line.setAttribute('x1', (140 - (96 - w)).toFixed(1)); line.setAttribute('x2', (140 + (96 - w)).toFixed(1)); }
      }
    }

    function finderLink(q) {
      var u = finder + '&units=mm&source=' + src;
      if (q.id) u += '&id=' + f2(q.id) + '&cs=' + f2(q.cs);
      if (q.mat) u += '&material=' + (q.mat === 'S' ? 'SILICONE' : X.MAT[q.mat][0]);
      if (q.hard) u += '&hardness=' + q.hard;
      if (q.dash) u += '&standard=AS568&standard_code=-' + q.dash;
      return u;
    }
    function rfqLink(q) {
      var u = rfq + '?source=' + src + '&request_mode=' + (q.exact ? 'BULK' : 'CUSTOM');
      if (q.id) u += '&id=' + f2(q.id) + '&cs=' + f2(q.cs) + '&units=mm';
      if (q.mat) u += '&material=' + X.MAT[q.mat][0];
      if (q.hard) u += '&hardness=' + q.hard + 'A';
      if (q.dash) u += '&standard=AS568&standard_code=-' + q.dash;
      return u;
    }

    function show(fromSubmit) {
      out.hidden = false;
      if (fromSubmit && out.getBoundingClientRect().top > window.innerHeight - 120) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function message(text, fromSubmit) { out.replaceChildren(el('p', 'ic-qf__msg', text)); show(fromSubmit); }

    function render(q, index) {
      var run = seq;
      var frag = document.createDocumentFragment();
      var label = f2(q.id) + ' × ' + f2(q.cs) + ' mm' + (q.unit === 'in' ? ' (' + q.rawId + ' × ' + q.rawCs + ' in)' : '');
      var rows = X.exact(index, q.id, q.cs);
      var codes = rows.length ? rows[0].codes.filter(function (c) { return (!q.mat || c.m === q.mat) && (!q.hard || c.h === q.hard); }) : [];
      q.exact = codes.length > 0;
      var head = el('div', 'ic-qf__head');
      var title = el('h2', 'ic-h3', q.exact ? 'Exact size · ' + label : rows.length ? label + ' is listed in other grades' : 'No listed size at ' + label);
      head.appendChild(title);
      if (rows.length) head.appendChild(el('span', 'ic-note', rows[0].codes.length + ' material / hardness options at this size'));
      frag.appendChild(head);
      // Keep the full-size finder link above long result lists, not only beneath them.
      if (rows.length && rows[0].codes.length > MAX_ROWS) {
        var allTop = el('p', 'ic-qf__all-top');
        var allLink = el('a', 'ic-link', 'View all ' + rows[0].codes.length + ' material / hardness options →');
        allLink.href = finderLink(q);
        allTop.appendChild(allLink);
        frag.appendChild(allTop);
      }

      if (q.exact) {
        var wrap = el('div', 'ic-table-wrap');
        var table = el('table', 'ic-table ic-table--catalog');
        table.innerHTML = '<thead><tr><th scope="col">Size</th><th scope="col">Material</th><th scope="col" class="ic-col-ref">Size ref.</th><th scope="col">Smallest pack</th><th scope="col" class="ic-col-stat">Status</th><th scope="col"><span class="ic-sr">Action</span></th></tr></thead>';
        var tbody = el('tbody'); table.appendChild(tbody); wrap.appendChild(table); frag.appendChild(wrap);
        // Only for a size with >8 available material/grade choices: show one
        // representative of each material family before other grade variants.
        // The full codes list stays unchanged; customer-selected filters win.
        var orderedCodes = codes;
        if (codes.length > MAX_ROWS) {
          var familyOrder = ['N', 'F', 'E', 'S', 'K'];
          var commonGrades = { N: '70', F: '75', E: '70', S: '70', K: '75' };
          var familyFirst = [];
          familyOrder.forEach(function (family) {
            var candidates = codes.filter(function (c) { return c.m === family; });
            if (!candidates.length) return;
            var featured = candidates.find(function (c) { return String(c.h) === commonGrades[family]; }) || candidates[0];
            familyFirst.push(featured);
          });
          orderedCodes = familyFirst.concat(codes.filter(function (c) { return familyFirst.indexOf(c) === -1; }));
        }
        var shown = orderedCodes.slice(0, MAX_ROWS);
        // For unfiltered large matches, show one row per material first;
        // keep other displayed grades one click away without deleting any items.
        var compactResults = codes.length > MAX_ROWS && !q.mat && !q.hard;
        var visibleRows = 5;
        shown.forEach(function (c, rowIndex) {
          var h = X.handleFor(index, rows[0], c);
          var ph = el('tr', 'ic-row ic-row--loading'); var td = el('td', null, X.MAT[c.m][0] + ' ' + c.h + 'A'); td.colSpan = 6; td.appendChild(el('span', 'ic-skel')); td.appendChild(el('span', 'ic-skel ic-skel--short')); ph.appendChild(td);
          if (compactResults && rowIndex >= visibleRows) { ph.hidden = true; ph.style.display = 'none'; }
          tbody.appendChild(ph);
          fetchRow(h).then(function (tr) {
            if (run !== seq) return;
            if (tr) {
              // Preserve the collapsed/expanded state even when AJAX rows load later.
              tr.hidden = ph.hidden;
              if (ph.hidden) tr.style.display = 'none';
              var packLink = tr.querySelector('a.ic-qa__packs');
              if (packLink) {
                // Preserve the existing screen-reader detail, href and click behavior.
                for (var n = packLink.firstChild; n; n = n.nextSibling) {
                  if (n.nodeType === 3) { n.nodeValue = 'View pack options'; break; }
                }
              }
              ph.replaceWith(tr);
            } else { var a = el('a', 'ic-link', X.MAT[c.m][0] + ' ' + c.h + 'A · open product'); a.href = '/products/' + h; td.replaceChildren(a); ph.classList.remove('ic-row--loading'); }
          });
        });
        if (compactResults) {
          var toggle = el('button', 'ic-btn ic-btn--ghost ic-qf__toggle', 'Show 3 more material / hardness options');
          toggle.type = 'button';
          toggle.setAttribute('aria-expanded', 'false');
          toggle.addEventListener('click', function () {
            var expanded = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(expanded));
            for (var i = visibleRows; i < tbody.children.length; i++) {
              tbody.children[i].hidden = !expanded;
              tbody.children[i].style.display = expanded ? '' : 'none';
            }
            toggle.textContent = expanded ? 'Show fewer options' : 'Show 3 more material / hardness options';
          });
          frag.appendChild(toggle);
        }
        if (codes.length > MAX_ROWS) {
          var more = el('p', 'ic-qf__more');
          var a = el('a', 'ic-link', 'Compare all ' + codes.length + ' options in the size finder →'); a.href = finderLink(q); more.appendChild(a); frag.appendChild(more);
        }
      } else if (rows.length) {
        var chips = el('div', 'ic-qf__chips');
        chips.appendChild(el('p', 'ic-small', 'Available at this size:'));
        rows[0].codes.slice(0, 18).forEach(function (c) { var a = el('a', 'ic-chip', X.MAT[c.m][0] + ' ' + c.h + 'A'); a.href = '/products/' + X.handleFor(index, rows[0], c); chips.appendChild(a); });
        frag.appendChild(chips);
      }

      var near = X.nearby(index, q.id, q.cs, 6);
      if (near.length) {
        var nb = el('div', 'ic-qf__near');
        nb.appendChild(el('h3', 'ic-h4', 'Nearby listed sizes'));
        nb.appendChild(el('p', 'ic-note', 'For comparison only. A nearby size is not an equivalent; check your gland or ask for a review before substituting.'));
        var ul = el('ul');
        near.forEach(function (n) {
          var li = el('li'); var a = el('a');
          a.href = finder + '&units=mm&id=' + f2(n.row.id) + '&cs=' + f2(n.row.cs) + '&source=' + src + '-nearby';
          a.appendChild(el('span', 'ic-num', f2(n.row.id) + ' × ' + f2(n.row.cs) + ' mm'));
          a.appendChild(el('small', 'ic-num', 'ID ' + (n.dId >= 0 ? '+' : '') + f2(n.dId) + ' · CS ' + (n.dCs >= 0 ? '+' : '') + f2(n.dCs)));
          li.appendChild(a); ul.appendChild(li);
        });
        nb.appendChild(ul); frag.appendChild(nb);
      }

      var act = el('div', 'ic-qf__actions');
      var f = el('a', 'ic-btn ic-btn--ghost', 'Open in size finder'); f.href = finderLink(q); f.setAttribute('data-ic-qf-open', ''); act.appendChild(f);
      var r = el('a', q.exact ? 'ic-btn ic-btn--ghost' : 'ic-btn ic-btn--primary', q.exact ? 'Quote a larger quantity' : 'Request this size (custom / sourcing)'); r.href = rfqLink(q); act.appendChild(r);
      frag.appendChild(act);

      out.replaceChildren(frag); show(q.submit);
      track('oxx_quickfind_result', { match_state: q.exact ? 'exact' : rows.length ? 'other_grades' : near.length ? 'nearby_only' : 'no_match', unit_system: q.unit || 'mm', material: q.mat ? X.MAT[q.mat][0] : '', hardness: q.hard || '', source: src });
    }

    function run(fromSubmit) {
      var p = panels.filter(function (x) { return !x.hidden; })[0];
      if (!p) return;
      var mode = p.dataset.icQfPanel;
      var mat = (p.querySelector('[data-ic-qf-mat]') || {}).value || '';
      var hard = (p.querySelector('[data-ic-qf-hard]') || {}).value || '';
      var q = { mat: mat, hard: hard, submit: fromSubmit };
      var my = ++seq;
      if (mode === 'size') {
        var unit = (p.querySelector('input[name="unit"]:checked') || { value: 'mm' }).value;
        var id = num(p.querySelector('[data-ic-qf-id]').value), cs = num(p.querySelector('[data-ic-qf-cs]').value);
        if (!(id > 0) || !(cs > 0)) { setRing(id > 0 ? id * (unit === 'in' ? 25.4 : 1) : 0, 0); if (fromSubmit) message('Enter both the inside diameter and the cross section.', true); return; }
        q.unit = unit; q.rawId = p.querySelector('[data-ic-qf-id]').value.trim(); q.rawCs = p.querySelector('[data-ic-qf-cs]').value.trim();
        q.id = unit === 'in' ? id * 25.4 : id; q.cs = unit === 'in' ? cs * 25.4 : cs;
        setRing(q.id, q.cs);
        X.sizeIndex(root.dataset.indexUrl).then(function (index) { if (my === seq) render(q, index); }).catch(function () { message('The size index could not load. Open the size finder instead.', fromSubmit); });
      } else if (mode === 'dash') {
        var d = String(p.querySelector('[data-ic-qf-dash]').value || '').replace(/[^0-9]/g, '');
        if (!d) { if (fromSubmit) message('Enter an AS568 dash number, e.g. 214.', true); return; }
        q.dash = ('00' + d).slice(-3);
        Promise.all([X.loadJSON(root.dataset.as568Url), X.sizeIndex(root.dataset.indexUrl)]).then(function (res) {
          if (my !== seq) return;
          var row = res[0].rows.filter(function (r) { return r.d === q.dash; })[0];
          if (!row) { message('AS568 -' + q.dash + ' is not in the public size reference. Check the number or search by dimensions.', fromSubmit); return; }
          q.id = row.im; q.cs = row.cm; q.unit = 'mm';
          setRing(q.id, q.cs);
          render(q, res[1]);
          var note = el('p', 'ic-note ic-qf__ref', 'AS568 -' + q.dash + ' · nominal ' + Number(row.ii).toFixed(3) + '" × ' + Number(row.ci).toFixed(3) + '" (public size reference, not an official validation).');
          out.insertBefore(note, out.firstChild);
        }).catch(function () { message('The size reference could not load. Open the size finder instead.', fromSubmit); });
      }
    }

    panels.forEach(function (p) {
      if (p.dataset.icQfPanel === 'text') return;
      p.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); run(true); });
      p.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { run(false); }, 220); });
      p.addEventListener('change', function () { clearTimeout(timer); run(false); });
    });
  }

  // Depends on window.OXXIC from oxx-ic.js, which is deferred later in the document:
  // DOMContentLoaded fires only after every deferred script has run.
  function boot() { document.querySelectorAll('[data-ic-quickfind]').forEach(init); }
  if (window.OXXIC) boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
